import PortalCheckboxGroup from './PortalCheckboxGroup.js';

export default PortalCheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalCheckboxGroup/index.js